import React, { useRef } from 'react';
import logoSrc from '../img/logo.png'; // Assuming the logo is in the img folder
import './About.css'; // Import the About.css file
import ContactForm from '../ContactForm'; // Make sure this component has the `openForm` method.
function CvPage() {
  

 const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };


  return (
    <>
    
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          <div className="banner-text">
            <h1 className="banner-title">meet the minds behind our success</h1>
            <p className="banner-description">
              Our team consists of highly skilled professionals in various fields including programming, graphic design, and leadership.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>

          </div>
          <div className="banner-background"></div>
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/About Us Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
            />
      </div>
      <section className="about-section">
        {/* Programmers Section */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Programmers</strong></h2>
            <ul>
              <li><strong>Skills:</strong> Proficient in front-end and back-end technologies, including HTML, CSS, JavaScript, React, Node.js, and more.</li>
              <li><strong>Experience:</strong> 3+ years in web development with a strong focus on responsive design and efficient coding practices.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/as6.1.png" alt="Programmers" />
          </div>
        </div>

        {/* Graphic Designers Section */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Graphic Designers</strong></h2>
            <ul>
              <li><strong>Skills:</strong> Expertise in Adobe Suite, web design, UI/UX design, and creating visually compelling digital assets.</li>
              <li><strong>Experience:</strong> 2+ years in designing user-friendly and aesthetically appealing interfaces and logos.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/as6.2.png" alt="Graphic Designers" />
          </div>
        </div>

        {/* CTO Section */}
        
        <div className="about-row">
  <div className="about-text">
    <h2><strong>Marketing Experts</strong></h2>
    <ul>
      <li><strong>Skills:</strong> Proven expertise in digital marketing, SEO, social media campaigns, and brand strategy development.</li>
      <li><strong>Experience:</strong> 4+ years in creating and executing data-driven marketing strategies for a variety of industries.</li>
    </ul>
  </div>
  <div className="about-image">
    <img src="/img/as6.3.png" alt="Marketing Experts" />
  </div>
</div>
<div className="about-row reverse" >
          <div className="about-text">
            <h2><strong>Project Managers</strong></h2>
            <ul>
              <li><strong>Skills:</strong> Extensive experience in technology strategy, project management, and leading teams to deliver scalable solutions.</li>
              <li><strong>Experience:</strong> 5+ years in leading tech teams, ensuring alignment between business goals and technical capabilities.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/as6.4.png" alt="CTO" />
          </div>
        </div>
      </section>
        <ContactForm ref={contactFormRef} />
      
    </>
  );
}

export default CvPage;
